import { Amenity } from "@app/models/Amenity";
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class AmenityApi extends HOAApiBase {

    constructor() {
        super("AmenityApi");
    }

    public activeAmenitiesByCouponGet(anon: boolean, pmcCouponId: string, hoaCouponId: string, propertyCouponId: string): Observable<Amenity[]> {
        const url = anon
            ? this.createUrl('HOAPass', `/amenities/coupons/${pmcCouponId}/${hoaCouponId}/status/active`)
            : this.createUrl('hoa-gateway', `/amenities/coupons/${pmcCouponId}/${hoaCouponId}/status/active`)

        return this.http.get<Amenity[]>(url, {
            params: {
                'propertyCouponId': propertyCouponId
            }
        })
    }

}

